import { getDoc, updateDoc } from "firebase/firestore";
import { getNotificationsDocRef } from ".";

const getNotificationsDoc = async () => {
  const notificationsDocRef = await getNotificationsDocRef();
  const notificationsDoc = await getDoc(notificationsDocRef);
  return notificationsDoc.data();
};

const updateNotificationsDoc = async ({
  newsletter,
  important_updates,
}: {
  newsletter: boolean;
  important_updates: boolean;
}) => {
  const notificationsDocRef = await getNotificationsDocRef();
  const payload: any = {
		newsletter,
		important_updates,
	};
  await updateDoc(notificationsDocRef, payload);
};

export { getNotificationsDoc, updateNotificationsDoc };
